<form class="add-contact-balance-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INCORRECT_PAYMENT.CUSTOMER_BALANCE' | translate }}</h4>
  <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
    <div class="astral-layout-item">
      <app-autocomplete-remote
        [control]="form.controls['contact']"
        [helpText]="'INCORRECT_PAYMENT.HELP_TEXT.CONTACT'"
        [service]="filterService"
        [defaultSearch]="this.dataContext.payerName"
      ></app-autocomplete-remote>
    </div>
    <astral-select
      [control]="form.controls['leaseAgreementId']"
      [helpText]="'INCORRECT_PAYMENT.HELP_TEXT.LEASE'"
      [itemsSource]="leaseAgreements"
    ></astral-select>
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <app-money-box [control]="form.controls['amount']"></app-money-box>
      <astral-date-picker
        [control]="form.controls['businessTransactionDate']"
        [label]="'ACCOUNT.ACCOUNTING_DATE'"
        [model]="accountingDate"
        [isRequired]="true"
      ></astral-date-picker>
    </astral-layout-group>
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
